<template>
  <div>
    <FileDropZone
      v-if="canEdit"
      allow-click
      :multiple="true"
      @add-file="handleAddFiles"
    >
      <div class="w-full border border-solid border-gray-light p-4">
        <div class="grid grid-cols-4 gap-2">
          <template v-if="hasFiles">
            <div v-for="file in validFiles" :key="file" class="relative group">
              <survey-file-answer
                :file-url="file"
                :image-mode="true"
                :can-edit="canEdit"
                class="w-full aspect-square object-cover rounded"
                size="large"
              />
              <button
                type="button"
                class="bg-white rounded delete-button"
                @click.stop="handleRemoveFile(file)"
              >
                <icon :icon="DeleteSvg" class="text-red" />
              </button>
            </div>
          </template>
          <div
            class="border border-dashed border-gray rounded aspect-square flex items-center justify-center cursor-pointer w-20 h-20"
          >
            <icon :icon="mdiPlusCircleOutline" />
          </div>
        </div>
      </div>
    </FileDropZone>
    <div v-else-if="hasFiles" class="grid grid-cols-4 gap-2">
      <div v-for="file in validFiles" :key="file" class="relative">
        <survey-file-answer
          :file-url="file"
          :image-mode="true"
          :can-edit="canEdit"
          class="w-full aspect-square object-cover rounded"
          size="large"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent } from '@vue/composition-api';
import { FileDropZone } from '@/components/FileDropZone';
import { Icon } from '@/components/Icon';
import DeleteSvg from '@/assets/icons/delete.svg';
import { mdiPlusCircleOutline } from '@mdi/js';
import SurveyFileAnswer from './SurveyFileAnswer.vue';

export default defineComponent({
  name: 'SurveyFileDropZone',
  components: {
    FileDropZone,
    Icon,
    SurveyFileAnswer,
  },
  props: {
    files: {
      type: Array,
      required: true,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const validFiles = computed(() => props.files.filter(Boolean));
    const hasFiles = computed(() => validFiles.value.length > 0);

    const handleAddFiles = (event) => {
      emit('add-file', event);
    };

    const handleRemoveFile = (file) => {
      emit('remove-file', file);
    };

    return {
      validFiles,
      hasFiles,
      handleAddFiles,
      handleRemoveFile,
      DeleteSvg,
      mdiPlusCircleOutline,
    };
  },
});
</script>

<style scoped>
.delete-button {
  position: absolute;
  top: 4px;
  right: 8px;
}
</style>
